import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root'
})
export class EncDecCryptoService {
    private key = CryptoJS.enc.Base64.parse('wAdcn/q1zSo5XvqWnlcCUDZEUV6Acc7sl8StviwEde0=');

    encrypt(data: any): { iv: string; data: string } {
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), this.key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return {
            iv: CryptoJS.enc.Base64.stringify(iv),
            data: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
        };
    }

    decrypt(encryptedData: string, ivBase64: string): any {
        const iv = CryptoJS.enc.Base64.parse(ivBase64);
        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(encryptedData),
        });
        const decrypted = CryptoJS.AES.decrypt(
            cipherParams,
            this.key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        );
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }
}
